export const DEFAULT_CANCEL_BTN_TEXT = "Reset";

export const DEFAULT_SAVE_BTN_TEXT = "Save";
